import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('ts_cart') || '[]');
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('ts_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product) => {
    setItems((prev) => {
      if (prev.find((i) => i.product_id === product.product_id)) return prev;
      return [...prev, product];
    });
  };

  const removeItem = (productId) => {
    setItems((prev) => prev.filter((i) => i.product_id !== productId));
  };

  const removeItems = (productIds) => {
    const ids = new Set(productIds);
    setItems((prev) => prev.filter((i) => !ids.has(i.product_id)));
  };

  const clearCart = () => setItems([]);

  const total = items.reduce((sum, i) => sum + (i.discount_price || i.price), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, removeItems, clearCart, total, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
